import { render, staticRenderFns } from "./main-pc-logo.vue?vue&type=template&id=aea3a720&"
import script from "./main-pc-logo.vue?vue&type=script&lang=js&"
export * from "./main-pc-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports